/* istanbul ignore file */
import { Providers, ProviderState, SimpleProvider } from '@microsoft/mgt-element';
import jwt_decode from 'jwt-decode';

export const isExpired = (expireTime: string): boolean => {
  const normalizedTime = parseInt(expireTime, 10) * 1000; // convert to milliseconds
  return Date.now() > new Date(normalizedTime).getTime();
};

export const getDecodedB2cToken = (b2cToken?: string | null) => {
  if (!b2cToken || typeof b2cToken !== 'string') return {} as any;
  try {
    const decodedB2CToken = jwt_decode(b2cToken) as any;
    return decodedB2CToken;
  } catch (_e) {
    return {} as any;
  }
};

export const getDecodedIdpToken = (idpToken?: string | null) => {
  if (!idpToken || typeof idpToken !== 'string') return {} as any;
  try {
    const decodedIDPToken = jwt_decode(idpToken) as any;
    return decodedIDPToken;
  } catch (_e) {
    return {} as any;
  }
};

export const calculateTokenRemainingTime = (expireTime: string): number => {
  const normalizedTime = parseInt(expireTime, 10) * 1000;
  const dateNow = Date.now();
  const validityTime = new Date(normalizedTime).getTime();
  const timeLeft = validityTime - dateNow;

  const minutes = Math.floor((timeLeft / 1000 / 60) % 60);
  const milliSeconds = minutes * 60 * 1000;

  return milliSeconds;
};

export const setMGTExplicitSignIn = (authToken: string) => {
  // Set MGT Provider idp_access_token from B2C token
  Providers.globalProvider = new SimpleProvider((scopes: string[]) => {
    return new Promise((resolve) => {
      const decodedB2cToken = getDecodedB2cToken(authToken);
      resolve(decodedB2cToken.idp_access_token);
    });
  });

  // Explicitly set MGT Provider state to SignedIn
  Providers.globalProvider.setState(ProviderState.SignedIn);
};
